var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.signedIn)?_c('UnloggedLayout'):_vm._e(),(_vm.signedIn)?_c('Layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }